import { Stack, Button, styled } from "@mui/material";
import { NoConnectionText } from "components/typography/text";
import React from "react";
import noConnectionImage from "../assets/images/no-connection.jpg"
import { urlNoConnectionPage } from "services/utils/globalVariables";
import { useNavigate } from "react-router-dom";

const NoConnectionContainer = styled(Stack)(
    ({ theme }) => `
        height: calc(100vh - 240px);
        justify-content: center;
        align-items: center;
    `
)

const NoConnectionBack = styled(Stack)(
    ({ theme }) => `
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: auto;
        & img {
            width: 100%;
            height: auto;
        }
    `
)

const ReloadButton = styled(Button)(
    ({ theme }) => `
        max-width: 120px;
    `
)

export default function NoConnectionPage() {

    const navigate = useNavigate()

    //if user is NOT online then just keep user in this page else navigate it to home page
    const handleReloadPage = () => {
        if(window.navigator.onLine) {
            navigate("/")
        } else {
            navigate(urlNoConnectionPage)
        }
    }

    return (
        <NoConnectionContainer className="noConnection">
            <Stack spacing={4} justifyContent="center" alignItems="center">
                <NoConnectionText>
                    همراه گرامی، ارتباط شما قطع می باشد.
                </NoConnectionText>
                <ReloadButton onClick={handleReloadPage} variant="contained" color="primary">
                    تلاش مجدد   
                </ReloadButton>
            </Stack>
            <NoConnectionBack>
                <img src={noConnectionImage} alt="" />
            </NoConnectionBack>
        </NoConnectionContainer>
    )
}